import Box from '@mui/material/Box';
import Typography from "@mui/material/Typography";
import React from 'react';

type HeaderFieldVariant = 'primary' | 'secondary';
type HeaderFieldProps = {
  'data-testid'?: string;
  children: React.ReactNode;
  variant?: HeaderFieldVariant;
};

const VARIANT_TYPOGRAPHY = {
  primary: { typographyVariant: 'text3', color: 'text.primary', 'data-testid': 'primaryText' },
  secondary: {
    typographyVariant: 'text4',
    color: 'text.secondary',
    'data-testid': 'secondaryText',
  },
} as const;

export const HeaderField = ({ children, variant = 'primary' }: HeaderFieldProps) => {
  const { typographyVariant, color, 'data-testid': testid } = VARIANT_TYPOGRAPHY[variant];

  return (
    <Typography variant={typographyVariant} color={color}>
      <Box data-testid={testid}>{children}</Box>
    </Typography>
  );
};
